import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { insideLook } from '../data/content';
export function InsideLook() {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const go = (next: number) => {
    setDirection(next > index ? 1 : -1);
    setIndex((next + insideLook.length) % insideLook.length);
  };
  const current = insideLook[index];
  return <section className="w-full bg-slate-50 py-16 sm:py-24" aria-labelledby="inside-look-title" data-id="element-118" data-mp="2uz8wxxfk2d24">
      <div className="mx-auto max-w-4xl px-6" data-id="element-119" data-mp="2h8c72ed0k9yr">
        <div className="mx-auto max-w-3xl text-center" data-id="element-120" data-mp="2h7kny30ls4pd">
          <h2 id="inside-look-title" className="text-3xl font-extrabold leading-tight tracking-tight text-navy-deep sm:text-4xl" data-id="element-121" data-mp="2m6ni2sf1oqik">
            A Real Look Inside The System
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink/75" data-id="element-122" data-mp="3eojd1cj7r00r">
            Step-by-step protocols, visual reference tables, and printable tools — explained clearly
            for any family.
          </p>
        </div>

        <div className="relative mt-12" role="group" aria-roledescription="carousel" aria-label="Sample pages from the system" data-id="element-123" data-mp="1xw5003k432wk">
          <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm" data-id="element-124" data-mp="26u6vy4ozn5cz">
            <div className="relative aspect-[4/3] w-full sm:aspect-[3/2]" data-id="element-125" data-mp="2lijv1ajdh4bp">
              <AnimatePresence initial={false} custom={direction} mode="wait" data-id="element-126" data-mp="2glbdnc61t4bi">
                <motion.img key={current.src} custom={direction} initial={{
                opacity: 0,
                x: direction * 40
              }} animate={{
                opacity: 1,
                x: 0
              }} exit={{
                opacity: 0,
                x: direction * -40
              }} transition={{
                duration: 0.3,
                ease: 'easeOut'
              }} src={current.src} alt={current.caption} className="absolute inset-0 h-full w-full bg-white object-contain p-2" loading="lazy" data-id="element-127" data-mp="2ukktgaqcdwey" />
              </AnimatePresence>
            </div>
            <p className="border-t border-slate-100 px-5 py-4 text-center text-sm font-medium text-ink/70" aria-live="polite" data-id="element-128" data-mp="3584cdx049739">
              {current.caption}
            </p>
          </div>

          <button type="button" onClick={() => go(index - 1)} aria-label="Previous page" className="absolute left-2 top-1/2 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full border border-slate-200 bg-white text-navy shadow-md transition-colors hover:bg-navy hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-navy/40 sm:-left-5" data-id="element-129" data-mp="3e7j2uwga9hnr">
            <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-130" data-mp="rl3ikxkmzdb" />
          </button>
          <button type="button" onClick={() => go(index + 1)} aria-label="Next page" className="absolute right-2 top-1/2 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full border border-slate-200 bg-white text-navy shadow-md transition-colors hover:bg-navy hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-navy/40 sm:-right-5" data-id="element-131" data-mp="5t0lu58d6rs0">
            <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-132" data-mp="2911c9ket6w2i" />
          </button>
        </div>

        <div className="mt-6 flex items-center justify-center gap-3" data-id="element-133" data-mp="24zxyd3gbna3x">
          {insideLook.map((page, dotIndex) => <button key={page.src} type="button" onClick={() => go(dotIndex)} aria-label={`Go to page ${dotIndex + 1}: ${page.caption}`} aria-current={dotIndex === index} className={`h-2.5 rounded-full transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-navy/40 ${dotIndex === index ? 'w-8 bg-navy' : 'w-2.5 bg-slate-300 hover:bg-slate-400'}`} data-id="element-134" data-mp="208668ohiowbo" data-mpi={dotIndex} />)}
        </div>
      </div>
    </section>;
}